import React, { useState } from "react";
import { Box, Button, MenuItem, Typography, useTheme } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { StyledMenu } from "@/components/styled";
import SvgSelectArrowDown from "@/assets/icons/SVGSelectArrowDown.tsx";

const ADMIN_DROPDOWN_ITEMS = [
  { label: "Dashboard", navTo: "/dashboard" },
  { label: "Budget", navTo: "/budget" },
  { label: "Finance", navTo: "/finance" },
  { label: "Data Requests", navTo: "/data-requests" },
];

const AdminDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (navTo: string) => {
    navigate(navTo);
    handleClose();
  };

  const isItemActive = (itemNavTo: string, currentPath: string) =>
    currentPath === itemNavTo ||
    (itemNavTo === "/" && currentPath === "/budget");

  return (
    <>
      <Button
        variant="navigation"
        onClick={handleClick}
        endIcon={<SvgSelectArrowDown />}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          backgroundColor: open ? theme.palette.navigationActive : "transparent",
          "&:hover": {
            backgroundColor: theme.palette.navigationActive,
          },
          borderRadius: "12px",
          padding: "12px 32px",
          color: "white",
          fontWeight: 600,
          fontSize: "14px",
          textTransform: "none",
        }}
      >
        Administrator
      </Button>
      <StyledMenu
        id="admin-dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "admin-dropdown-button",
        }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#003257",
            color: "white",
            borderRadius: "12px",
            minWidth: "200px",
            marginTop: "4px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            border: "none",
          },
        }}
      >
        {ADMIN_DROPDOWN_ITEMS.map((item) => {
          const isActive = isItemActive(item.navTo, location.pathname);

          return (
            <MenuItem
              key={item.navTo}
              onClick={() => handleMenuItemClick(item.navTo)}
              sx={{
                padding: "12px 16px",
                backgroundColor: isActive ? theme.palette.navigationActive : "transparent",
                color: "white",
                "&:hover": {
                  backgroundColor: theme.palette.navigationActive,
                },
                "&.Mui-selected": {
                  backgroundColor: theme.palette.navigationActive,
                },
                "&.Mui-selected:hover": {
                  backgroundColor: theme.palette.navigationActive,
                },
                borderRadius: "0",
                border: "none",
                "&:first-of-type": {
                  borderTopLeftRadius: "12px",
                  borderTopRightRadius: "12px",
                },
                "&:last-of-type": {
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "white",
                }}
              >
                {item.label}
              </Typography>
            </MenuItem>
          );
        })}
      </StyledMenu>
    </>
  );
};

export default AdminDropdown;
